import { apiFetch, readJsonResponse } from './client';

const BASE = '/api/dashboard-filter-presets';

export async function listFilterPresets() {
  const response = await apiFetch(BASE);
  const data = await readJsonResponse(response, BASE);
  if (!response.ok) {
    throw new Error(data?.message || 'Не удалось загрузить пресеты');
  }
  return data.items || [];
}

export async function createFilterPreset({ name, query }) {
  const response = await apiFetch(BASE, {
    method: 'POST',
    body: JSON.stringify({ name, query }),
  });
  const data = await readJsonResponse(response, BASE);
  if (!response.ok) {
    throw new Error(data?.message || 'Не удалось создать пресет');
  }
  return data;
}

export async function updateFilterPreset(id, { name, query }) {
  const path = `${BASE}/${id}`;
  const body = {};
  if (name !== undefined) {
    body.name = name;
  }
  if (query !== undefined) {
    body.query = query;
  }
  const response = await apiFetch(path, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
  const data = await readJsonResponse(response, path);
  if (!response.ok) {
    throw new Error(data?.message || 'Не удалось обновить пресет');
  }
  return data;
}

export async function deleteFilterPreset(id) {
  const path = `${BASE}/${id}`;
  const response = await apiFetch(path, { method: 'DELETE' });
  const data = await readJsonResponse(response, path);
  if (!response.ok) {
    throw new Error(data?.message || 'Не удалось удалить пресет');
  }
  return data;
}
